export default {
    goodsPrice: {
        page: {
            PleaseCode: 'Please enter the price item code',
            PleaseName: 'Please enter the price item name',
            DuplicateName: 'Platform usage name already exists, please enter again',
            AddPrice: 'Add price item',
            EditPrice: 'Edit price item'
        },
        table: {
            code: 'Price item code',
            item: 'General price item',
            name: 'Platform usage name',
        }
    }
};
